export default "__VITE_ASSET__CQRVcvsH__"